import React from 'react';
import { Container } from '@material-ui/core';
import Page from '../../../components/Layout/Page';
import Header from './Header';
import ReportCreateForm from './ReportCreateForm';

import useStyles from './styles';

function ReportCreateView() {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="FH Engel | Crear Reporte"
    >
      <Container maxWidth={false}>
        <Header />
        <ReportCreateForm />
      </Container>
    </Page>
  );
}

export default ReportCreateView;
